import React from "react";
import "./Home.css"
import Github from "../../images/github.png";
import Linkedin from"../../images/linkedin.png";
import myphoto from "../../images/myphoto.png";
const Home = () =>{
    return(
        <div id="home" className="home">
            <div className="h-left">
                <div className="h-name">
                    <span>Hi! I am </span>
                    <span>Nistha Bajracharya</span>
                    <span>A Computer Engineering Student</span>
                </div>
                <a href="https://drive.google.com/file/d/1B6QKcpiG_ZEoE5xK4xgS-9of7c4iN2fR/view?usp=sharing"><button className="button h-button">My CV</button></a>
                <div className="h-icons">
                    <a href="https://github.com/Nis13" target="_blank"><img src={Github} alt="github" /></a>
                    <a href="https://www.linkedin.com/in/nistha-b-7214591b2/" target="_blank"><img src={Linkedin} alt="linkedin" /></a>
                </div>
            </div>
            <div className="h-right">
                <img className="my-photo" src={myphoto} alt="myphoto" />
            </div>
        </div>
    )
}
export default Home;